import { render } from "./EmptyData.vue?vue&type=template&id=a180fdd0"
import script from "./EmptyData.vue?vue&type=script&lang=js"
export * from "./EmptyData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/shared/EmptyData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a180fdd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a180fdd0', __exports__)) {
    api.reload('a180fdd0', __exports__)
  }
  
  module.hot.accept("./EmptyData.vue?vue&type=template&id=a180fdd0", () => {
    api.rerender('a180fdd0', render)
  })

}


export default __exports__